import React from 'react';
import { Box, Container, Paper } from '@mui/material';
import { Outlet } from 'react-router-dom';

const AuthLayout: React.FC = () => (
  <Box minHeight="100vh" display="flex" alignItems="center" bgcolor="background.default" py={4}>
    <Container maxWidth="sm">
      <Paper elevation={2} sx={{ p: { xs: 3, md: 4 }, borderRadius: 3 }}>
        <Outlet />
      </Paper>
    </Container>
  </Box>
);

export default AuthLayout;
